import React from 'react';

export default (
    <svg width="321px" height="138px" viewBox="0 0 321 138">
        <title>Group</title>
        <desc>Created with Sketch.</desc>
        <defs>
            <linearGradient
                x1="36.0164755%"
                y1="50%"
                x2="60.3708281%"
                y2="49.4116841%"
                id="linearGradient-1"
            >
                <stop stopColor="#F1F1F1" offset="0%" />
                <stop stopColor="#FBFBFB" offset="49.1422302%" />
                <stop stopColor="#F1F1F1" offset="100%" />
            </linearGradient>
            <linearGradient
                x1="36.0164755%"
                y1="50%"
                x2="60.3708281%"
                y2="49.2692576%"
                id="linearGradient-2"
            >
                <stop stopColor="#F1F1F1" offset="0%" />
                <stop stopColor="#FBFBFB" offset="49.1422302%" />
                <stop stopColor="#F1F1F1" offset="100%" />
            </linearGradient>
            <linearGradient
                x1="36.0164755%"
                y1="50%"
                x2="60.3708281%"
                y2="39.5444438%"
                id="linearGradient-3"
            >
                <stop stopColor="#F1F1F1" offset="0%" />
                <stop stopColor="#FBFBFB" offset="49.1422302%" />
                <stop stopColor="#F1F1F1" offset="100%" />
            </linearGradient>
        </defs>
        <g
            id="Messaging-MASTER-designs"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="Right-rail-live-group-chat"
                transform="translate(-1534.000000, -126.000000)"
            >
                <g id="Group" transform="translate(1534.000000, 126.000000)">
                    <path
                        d="M87,84 L290,84 C293.313708,84 296,86.6862915 296,90 L296,119.760792 C296,123.074501 293.313708,125.760792 290,125.760792 L104.350244,125.760792 C101.864406,130.683953 98.3281117,133.763689 93.7413621,135 C96.3272096,130.762047 97.4663424,127.682311 97.1587603,125.760792 L87,125.760792 C83.6862915,125.760792 81,123.074501 81,119.760792 L81,90 C81,86.6862915 83.6862915,84 87,84 Z"
                        id="Rectangle-Copy-5"
                        fill="url(#linearGradient-1)"
                        transform="translate(188.500000, 109.500000) scale(-1, 1) translate(-188.500000, -109.500000) "
                    />
                    <path
                        d="M30,0 L279,0 C282.313708,1.41071035e-14 285,2.6862915 285,6 L285,53.7599766 C285,57.0736851 282.313708,59.7599766 279,59.7599766 L47.3765006,59.7599766 C44.8878669,64.6835718 41.3475966,67.7635796 36.7556894,69 C39.3444446,64.7616725 40.4848582,61.6816647 40.1769303,59.7599766 L30,59.7599766 C26.6862915,59.7599766 24,57.0736851 24,53.7599766 L24,6 C24,2.6862915 26.6862915,-2.9439953e-15 30,0 Z"
                        id="Rectangle-Copy"
                        fill="url(#linearGradient-2)"
                    />
                    <circle
                        id="Oval"
                        fill="url(#linearGradient-3)"
                        cx="11"
                        cy="60"
                        r="11"
                    />
                    <circle
                        id="Oval-Copy"
                        fill="url(#linearGradient-3)"
                        cx="310"
                        cy="127"
                        r="11"
                    />
                </g>
            </g>
        </g>
    </svg>
);
